import type { Currency } from '@/types';

export const formatCurrency = (amount: number, currency: Currency): string => {
  switch (currency) {
    case 'KRW':
      return `₩${new Intl.NumberFormat('ko-KR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount)}`;
    case 'USD':
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(amount);
    case 'MXN':
      return `MX$${new Intl.NumberFormat('es-MX', {
        minimumFractionDigits: 2
      }).format(amount)}`;
    case 'EUR':
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(amount);
    default:
      return amount.toString();
  }
};
